import { useCallback, useState } from 'react';

export type ErrosForm<Campo extends string> = Partial<Record<Campo, string>>;

/**
 * Guarda os erros de validacao de um formulario, indexados pelo nome do campo.
 * Cada drawer monta o objeto de erros do seu jeito e passa para `validar`, que
 * devolve se o submit pode seguir.
 */
export function useErrosForm<Campo extends string>() {
	const [ erros, setErros ] = useState<ErrosForm<Campo>>({});

	// Some o erro assim que o campo passa a ser corrigido, sem esperar novo submit.
	const limparErro = useCallback((campo: Campo) => {
		setErros((anteriores) => (anteriores[campo] ? { ...anteriores, [campo]: undefined } : anteriores));
	}, []);

	const limparTudo = useCallback(() => setErros({}), []);

	const validar = useCallback((encontrados: ErrosForm<Campo>) => {
		setErros(encontrados);
		return Object.values(encontrados).filter(Boolean).length === 0;
	}, []);

	return { erros, validar, limparErro, limparTudo };
}
